import React from 'react';
import { Textarea, Text, Group } from '@mantine/core';
import { IJournalResponseInput, IFreeTextOptions } from '../../../../global/entities/Journal/Journal';

interface FreetextQuestionProps {
    questionId: number;
    response: IJournalResponseInput | undefined;
    onResponseChange: (questionId: number, updates: Partial<IJournalResponseInput>) => void;
    options?: IFreeTextOptions;
    readOnly?: boolean;
}

export const FreetextQuestion: React.FC<FreetextQuestionProps> = ({
    questionId,
    response,
    onResponseChange,
    options,
    readOnly = false
}) => {
    const maxLength = options?.maxLength || 500;
    
    const currentValue = response?.responseValue || '';
    const characterCount = currentValue.length;
    const isOverLimit = characterCount > maxLength;

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (readOnly) return;
        
        const value = event.target.value;
        
        // Don't allow input beyond maxLength
        if (value.length <= maxLength) 
            onResponseChange(questionId, { responseValue: value });
        
    };

    return (
        <>
            <Textarea
                value={currentValue}
                onChange={handleChange}
                rows={4}
                autosize
                minRows={2}
                maxRows={8}
                styles={{
                    input: {
                        resize: 'vertical'
                    }
                }}
            />
            
            <Group justify="space-between" mt="xs">
                <Text 
                    size="xs" 
                    c={isOverLimit ? 'red' : characterCount > maxLength * 0.8 ? 'orange' : 'dimmed'}
                    ml="auto"
                >
                    {characterCount} / {maxLength}
                </Text>
            </Group>
        </>
    );
};
